import styled from 'styled-components';

export const SocialediaButtonContainer = styled.div`
  overflow: hidden;
  border-radius: 50%;
  wdith: 50px;
  height: 50px;
  display: flex;
  justify-items: center;
  justify-content: center;
`;
